import { Typography, Form } from "antd";
import _ from "lodash";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GenericUsersTable } from "../../../components/tables/UsersTable";
import { OverlayContext } from "../../../context/OverlayContext";
import { ToastContext } from "../../../context/ToastContext";
import Account from "../../../models/Account";
import AccountService from "../../../services/crud/AccountService";
import DescriptionDataList from "../../../components/DescriptionDataList";
import { GenericSubscriptionsTable } from "../../../components/tables/SubscriptionsTable";
import { GenericHubsTable } from "../../../components/tables/HubsTable";
import { GoBackButton } from "../../../components/GoBackButton";

const includeColumnsUsers = ["username", "firstname", "lastname", "createdAt", "lastLoggedIn", "updatedAt", "actions"];
const includeColumnsSubscriptions = ["plan", "priceInclVat", "ends", "updatedAt", "actions"];
const includeColumnsHubs = ["name", "address", "updatedAt", "actions"];
type Props = {};
/**
 * This page is used for PRIVATE accounts.
 *
 * It only provides basic info. For deep debugging of private accounts, look into the database may be required.
 */
function AccountView({}: Props) {
  const { id } = useParams<any>();
  const accountId = parseInt(id);
  const [account, setAccount] = useState<Account>({} as Account);
  const { loading, loadMessage } = useContext(ToastContext);

  useEffect(() => {
    loadMessage("Loading Account...", () =>
      AccountService.getAccount(id).then((data) => {
        setAccount(data);
      })
    );
  }, [id]);

  return (
    <div>
      <GoBackButton></GoBackButton>
      <div>
        <Typography.Title level={3} style={{ marginTop: 40, marginLeft: 10 }}>
          {account?.name}
        </Typography.Title>
        <DescriptionDataList
          data={account}
        ></DescriptionDataList>
      </div>
      <GenericUsersTable
        actions={{ delete: true, select: true }}
        params={{ accountId }}
        includeColumns={includeColumnsUsers}
      ></GenericUsersTable>
      <GenericSubscriptionsTable params={{ accountId }} includeColumns={includeColumnsSubscriptions}></GenericSubscriptionsTable>
      <GenericHubsTable params={{ accountId }} includeColumns={includeColumnsHubs}></GenericHubsTable>
    </div>
  );
}

export default AccountView;
